<template>
  <v-sheet rounded elevation="1" class="cmd-bar px-4 py-3 mb-3">
    <!-- zone 1: navigation + actions -->
    <div class="d-flex align-center flex-wrap justify-space-between cmd-bar__nav" style="gap: 8px 12px">
      <div class="d-flex align-center flex-wrap cmd-bar__lead" style="gap: 8px 12px">
        <span v-if="total != null" class="cmd-bar__total">
          <v-icon x-small class="mr-1">mdi-car-multiple</v-icon>{{ total }}
        </span>
        <!-- скоуп как на bookings/list: Активные / Неактивные / Архив.
             Повторный клик по выбранному сегменту снимает фильтр (все машины);
             из архива «Активные/Неактивные» ведут обратно в список -->
        <v-btn-toggle v-if="view === 'list' || view === 'archive'" :value="scopeIndex" dense
          class="cmd-bar__seg cmd-bar__scope" data-testid="cars-scope">
          <v-btn small @click="setScopeActive(true)">
            <v-icon small>mdi-play-circle-outline</v-icon>
            <span class="ml-1">{{ $t("cars_board.scope_active") }}</span>
          </v-btn>
          <v-btn small @click="setScopeActive(false)">
            <v-icon small>mdi-history</v-icon>
            <span class="ml-1">{{ $t("cars_board.scope_inactive") }}</span>
          </v-btn>
          <v-btn small :to="{ name: 'ArchiveCars' }">
            <v-icon small>mdi-archive-outline</v-icon>
            <span class="ml-1">{{ $t("custom.archive") }}</span>
          </v-btn>
        </v-btn-toggle>
      </div>

      <div class="d-flex align-center cmd-bar__actions" style="gap: 8px">
        <div class="d-flex align-center" style="gap: 8px">
          <!-- в архиве переключатель вида неприменим — архив не список и не доска -->
          <v-btn-toggle v-if="view !== 'archive'" :value="view === 'list' ? 0 : 1" mandatory dense
            class="cmd-bar__seg">
            <v-btn small :to="{ name: 'CarsList' }">
              <v-icon small>mdi-format-list-bulleted</v-icon>
              <span class="hidden-xs-only ml-1">{{ $t("custom.list_view") }}</span>
            </v-btn>
            <v-btn small :to="{ name: 'CarsBoard' }">
              <v-icon small>mdi-view-column-outline</v-icon>
              <span class="hidden-xs-only ml-1">{{ $t("custom.board_view") }}</span>
            </v-btn>
          </v-btn-toggle>
        </div>

        <div class="d-flex align-center" style="gap: 8px">
          <v-btn v-if="view !== 'archive'" small color="success" :to="{ name: 'newCars' }"
            :disabled="!isStaff">
            <v-icon small>mdi-plus</v-icon>
            <span class="ml-1">{{ $t("custom.add") }}</span>
          </v-btn>

          <v-menu offset-y left min-width="210">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small v-bind="attrs" v-on="on"><v-icon>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <!-- выгрузка отфильтрованного парка в Excel (как на bookings/list);
                 в архиве экспорт не проводится -->
            <v-list-item v-if="view !== 'archive'" :disabled="!canExport" @click="$emit('export-xlsx')">
              <v-list-item-icon class="mr-3"><v-icon :color="xlsxLoading ? 'primary' : ''">mdi-file-excel-outline</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t("custom.export_excel") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('refresh')">
              <v-list-item-icon class="mr-3"><v-icon>mdi-refresh</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t("custom.refresh") }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item :href="helpHref" target="_blank">
              <v-list-item-icon class="mr-3"><v-icon>mdi-help-circle</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        </div>
      </div>
    </div>

    <v-divider class="cmd-bar__rule my-3"></v-divider>

    <!-- zone 2: search + filters -->
    <div class="d-flex align-center flex-wrap" style="gap: 8px 12px">
      <v-text-field v-model="searchText" :label="$t('custom.search')" prepend-inner-icon="mdi-magnify"
        clearable hide-details dense outlined class="cmd-bar__search" :data-testid="searchTestid"
        @input="onSearchInput" @click:clear="onSearchClear" />

      <!-- в архиве панель фильтров списка неприменима -->
      <v-menu v-if="view !== 'archive'" :close-on-content-click="false" offset-y left
        transition="slide-y-transition" eager>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small outlined class="cmd-bar__filters" v-bind="attrs" v-on="on">
            <v-icon left small>mdi-tune-variant</v-icon>{{ $t("crm.toolbar.filters") }}
            <span v-if="activeCount" class="cmd-bar__fbadge">{{ activeCount }}</span>
          </v-btn>
        </template>
        <cars-filter-panel :value="filters" :rental-object="rentalObject" :show-group="view === 'board'"
          @input="$emit('input', $event)" />
      </v-menu>
    </div>

    <!-- zone 3: active filter chips -->
    <div v-if="activeChips.length" class="d-flex align-center flex-wrap mt-3" style="gap: 8px">
      <v-chip v-for="chip in activeChips" :key="chip.key" small close class="cmd-bar__chip"
        @click:close="removeChip(chip.key)">
        <span class="cmd-bar__chipk">{{ chip.label }}:</span>&nbsp;{{ chip.text }}
      </v-chip>
      <v-btn small text class="cmd-bar__clear" @click="$emit('reset')">
        <v-icon left small>mdi-filter-off-outline</v-icon>{{ $t("custom.clear_all") }}
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
import CarsFilterPanel from "@/components/dashboard/cars/CarsFilterPanel.vue";
import { activeFilterChips, withFilterCleared } from "@/components/dashboard/cars/carsFilterChips";

export default {
  name: "CarsCommandBar",
  components: { CarsFilterPanel },
  props: {
    view: { type: String, default: "list" },
    total: { type: [Number, String], default: null },
    filters: { type: Object, required: true },
    rentalObject: { type: String, default: "cars" },
    // спиннер иконки Excel, пока идёт выгрузка (родитель держит isLoadingDownloadXlsx)
    xlsxLoading: { type: Boolean, default: false },
    // e2e-селектор поля поиска: у архива свой (archive-cars-search)
    searchTestid: { type: String, default: "cars-search" },
  },
  data() {
    return { searchText: (this.filters && this.filters.search) || "", searchTimer: null };
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  computed: {
    // подсветка сегмента скоупа: в архиве — «Архив» (2); в списке по filters.active:
    // true → 0, false → 1, null (все) — ничего
    scopeIndex() {
      if (this.view === "archive") return 2;
      const f = this.filters || {};
      return f.active === true ? 0 : f.active === false ? 1 : undefined;
    },
    helpHref() {
      const locale = this.$root.$i18n.locale;
      return `https://rentprog.${locale === "ru" ? "ru" : "com"}/${locale}/categories/2`;
    },
    // экспорт закрыт для guest/agent — совпадает с серверным гардом /cars/list_export;
    // partner видит только свои авто, поэтому кнопку ему оставляем
    canExport() {
      // Положительный набор, а не «не guest и не agent»: отрицание через
      // геттеры — тот же fail-open, что и через литералы, новая роль прошла бы
      // молча. Партнёр оставлен намеренно: он видит только свои машины.
      return this.isStaff || this.isPartner;
    },
    activeChips() {
      return activeFilterChips(this.filters, { t: this.$t.bind(this), rentalObject: this.rentalObject });
    },
    activeCount() { return this.activeChips.length; },
  },
  watch: {
    "filters.search"(v) {
      if ((v || "") !== this.searchText) this.searchText = v || "";
    },
  },
  methods: {
    // скоуп-сегмент пишет в общий filters.active (панель фильтров/чипы остаются в синхроне);
    // клик по уже выбранному сегменту снимает фильтр → все машины.
    // Из архива — навигация обратно в список с нужным скоупом (carsQueryState читает q.active)
    setScopeActive(value) {
      if (this.view === "archive") {
        this.$router.push({ name: "CarsList", query: { active: value ? "1" : "0" } });
        return;
      }
      const next = this.filters.active === value ? null : value;
      this.$emit("input", { ...this.filters, active: next });
    },
    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        const q = (this.searchText || "").trim();
        const next = q.length >= 2 ? q : null;
        if ((this.filters.search || null) === next) return;
        this.$emit("input", { ...this.filters, search: next });
      }, 300);
    },
    onSearchClear() {
      this.searchText = "";
      this.$emit("input", { ...this.filters, search: null });
    },
    removeChip(key) {
      this.$emit("input", withFilterCleared(this.filters, key));
    },
  },
};
</script>

<style scoped>
.cmd-bar__total {
  font-size: 0.85rem;
  font-weight: 600;
  opacity: 0.6;
  display: inline-flex;
  align-items: center;
}
/* segmented controls: outlined group so the buttons read as one unit */
.cmd-bar__seg {
  background: rgba(127, 127, 127, 0.08);
  border: 1px solid rgba(127, 127, 127, 0.35);
  border-radius: 10px;
  padding: 2px;
}
.cmd-bar__seg >>> .v-btn {
  text-transform: none;
  letter-spacing: 0;
  border: none !important;
  border-radius: 8px !important;
  margin: 0 !important;
  background: transparent !important;
}
.cmd-bar__seg >>> .v-btn.v-btn--active {
  background: rgba(127, 127, 127, 0.3) !important;
}
.cmd-bar__rule {
  opacity: 0.6;
}
.cmd-bar__search {
  flex: 2 1 260px;
  min-width: 200px;
}
.cmd-bar__filters {
  text-transform: none;
  letter-spacing: 0;
  height: 40px !important;
}
.cmd-bar__fbadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  margin-left: 7px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
  background: var(--v-success-base, #4caf50);
  color: #fff;
}
.cmd-bar__chip {
  font-size: 12px;
}
.cmd-bar__chipk {
  opacity: 0.6;
}
.cmd-bar__clear {
  text-transform: none;
  letter-spacing: 0;
}
/* Mobile: actions span a full row; search shares its row with Filters. */
@media (max-width: 599px) {
  .cmd-bar__lead {
    width: 100%;
  }
  .cmd-bar__actions {
    width: 100%;
    justify-content: space-between;
  }
  .cmd-bar__search {
    flex: 1 1 140px;
    min-width: 0;
  }
}
</style>
